import React, { HTMLAttributes } from 'react';
import { TwicImg } from '@twicpics/components/react';

export type Props = React.PropsWithChildren<{
  src: string;
  alt?: string;
  className?: string;
  ratio?: string;
  preTransform?: string;
}>;

export default function Image({
  src,
  alt,
  className = '',
  ratio = '3/4',
  preTransform = 'quality=85',
  children,
}: Props): JSX.Element {
  if (!src.length) {
    return <EmptyImage className={className} />;
  }

  return (
    <TwicImg
      className={className}
      src={src}
      alt={alt || src}
      ratio={ratio}
      preTransform={preTransform}
    >
      {children}
    </TwicImg>
  );
}

function EmptyImage({
  className,
}: HTMLAttributes<HTMLImageElement>): JSX.Element {
  return (
    <img
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
      className={className}
    />
  );
}
